var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('vx-router-view'),(_vm.showImg)?_c('div',{staticClass:"app1"},[_c('img',{staticClass:"img",attrs:{"src":_vm.url,"alt":""},on:{"click":_vm.prewImg}})]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }